import { useEffect } from "react";
import { trans } from "~/providers/lang";

import { setCanonical } from "~/utils/seo";
import { addMeta } from "~/utils/utils";

interface IUseSeo {
	title: string;
	canonical: string;
}

export function useSeo({
	title,
	canonical,
}: IUseSeo) {
	useEffect(() => {
		const finalCanonical = `${location.origin}/${canonical}`;
		const desc = trans("skelet.description");

		document.title = title;
		setCanonical(finalCanonical);
		addMeta("description", desc);
		addMeta("og:url", finalCanonical);
		// console.log(["seo", title, finalCanonical, desc]);
	}, []);
}
